import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ProfessionalBeautyStandardsHero from "./sections/ProfessionalBeautyStandardsHero";
import ComplianceAndTrustCredentials from "./sections/ComplianceAndTrustCredentials";
import FeaturedProductCategories from "./sections/FeaturedProductCategories";
import TheDailyEssentials from "./sections/TheDailyEssentials";
import InternationalBusinessInquiries from "./sections/InternationalBusinessInquiries";
import CorporateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <ProfessionalBeautyStandardsHero />
      <ComplianceAndTrustCredentials />
      <FeaturedProductCategories />
      <TheDailyEssentials />
      <InternationalBusinessInquiries />
      <CorporateFooter />
    </div>;
}